/** @format */
import { lighten, margin } from "polished";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const createColumnDefs = () => {
  return [
    {
      headerName: "",
      field: "",
      maxWidth: 50,
      minWidth: 50,
      enableCellTextSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      filter: false,
      suppressMenu: true,
    },
    {
      headerName: "",
      field: "expand",
      maxWidth: 70,
      minWidth: 50,
      suppressMenu: true,
      filter: false,
      cellRenderer: (params) => {
        // isRowMaster kontrolü: Sadece detay satırı olanlarda buton görünsün
        if (!params.data.taxpayerIds || params.data.taxpayerIds.length === 0) {
          return null;
        }
        // Açık/kapalı durumuna göre ikon belirle
        const isExpanded = params.node.expanded;

        return (
          <button
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              width: "100%",
              height: "100%",
            }}
            onClick={() => params.node.setExpanded(!isExpanded)}
            aria-label={isExpanded ? "Detayları kapat" : "Detayları aç"}
          >
            {isExpanded ? (
              <KeyboardArrowDownIcon />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </button>
        );
      },
    },
    {
      field: "email",
      headerName: "E-Posta",
      filter: "agTextColumnFilter", // Doğru kullanım
      maxWidth: 270,
      autoHeight: true,
    },
    {
      field: "username",
      headerName: "Kullanıcı Adı",
      maxWidth: 150,
    },
    {
      field: "createdAt",
      headerName: "Oluşturulma Tarihi",
      maxWidth: 140,
    },
    {
      field: "updatedAt",
      headerName: "Son Güncelleme Tarihi",
      maxWidth: 140,
    },
    {
      headerName: "Durum",
      field: "status",
      flex: 0,
      cellRenderer: (params) => {
        // Gelen veriye göre renk ve metin belirle
        let buttonText = "";
        if (params.value === true) {
          buttonText = "Aktif";
        } else {
          buttonText = "Pasif";
        }

        // Buton oluştur
        return (
          <button
            sx={{
              textTransform: "none",
              mb: "3%",
            }}
            style={{
              backgroundColor:
                buttonText === "Aktif"
                  ? lighten(0.4, "#5cb85c")
                  : lighten(0.3, "#f0ad4e"),
              color: buttonText === "Aktif" ? "#12450f" : "#b3545c",
              padding: "6px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              width: "130px", // Tüm butonların genişliği (örneğin 200 piksel)
              "&:hover": {
                backgroundColor: "#1565c0", // Hover rengi
              },
            }}
          >
            {buttonText}
          </button>
        );
      },

      filterParams: {
        valueFormatter: function (params) {
          if (params.value === true) {
            return "Aktif";
          } else if (params.value === false) {
            return "Pasif";
          }
        },
      },
    },
  ];
};
export default createColumnDefs;
